<div class="contact-container">
    <div class="logo">
        <img src="/assets/img/phoenix-logo.png" alt="phoenix" class="logo-phoenix">
    </div>
    <h1 class="contact-title">Contáctanos</h1>

    <div class="contact-us">
        <p>Correo electrónico: informes&#64;phoenix.com.pe</p>
        <p>Celular: 991 045 611</p>
        <p>Dirección: Call. 02 de Mayo 516 - interior 201 - Miraflores - Lima</p>
    </div>
    <br>
    <div class="container-button">
        <button class="boton-principal" (click)="return()">Regresar</button>
    </div>
</div>